import {
  useGetService,
  type UseGetServiceOptions,
} from "@libs/service-providers/api-service-provider";

import { DOMAINS_URL } from "./apiEndpoints";
import type { ApiResponse, DomainItem } from "./types";

type UseGetDomainsOptions = Omit<
  UseGetServiceOptions<ApiResponse<DomainItem[]>>,
  "route" | "queryKey"
>;

export const useGetDomains = (options?: UseGetDomainsOptions) =>
  useGetService<ApiResponse<DomainItem[]>>({
    route: DOMAINS_URL,
    queryKey: ["dq-dashboard", "domains"],
    retry: false,
    ...(options ?? {}),
  });
